import React from 'react';

import isEqual from 'lodash/isEqual';

import Sessions from 'Services/Api/MainStage/Sessions';
import {resourceDateIsBeforeNow, resourceDateIsAfterNow} from 'Services/DateHelpers';
import {Toast, Socket, User} from 'Services';

export default class Base extends React.Component {
    /**
     * @method mountBase
     */
    mountBase = () => {
        this.fetchSessions();

        //this.subscribeToBroadcasts();

        //this.interval = setInterval(this.updateSessions, 2000); // 2 seconds
    }

    /**
     * @method unmountBase
     */
    unmountBase = () => {
        Socket.getConnection().leave('main_stage_sessions');

        window.clearInterval(this.interval);
    }

    /**
     * @method fetchSessions
     * @param {boolean} initialLoad
     * @return {Promise<void>}
     */
    fetchSessions = async (initialLoad = true) => {
        if (initialLoad) {
            this.setState({working: true});
        }

        let params = {
            live_and_upcoming_sessions: 1,
            my_language: 1
        };

        if (this.remote_control) {
            params.remote_control = 1;
        }

        const request = await Sessions.get(null, params);

        if (request.success) {
            return this.setState({
                sessions: request.data.data,
                working: false,
            }, this.updateSessions);
        }

        Toast.error();
    };

    /**
     * @method subscribeToBroadcasts
     */
    subscribeToBroadcasts = () => {
        Socket.getConnection()
            .private(`main_stage_sessions`)
            .listen('MainStageSessionsUpdated', (e) => {
                this.handleSessionUpdatedBroadcast(e.session);
            })
            .listen('MainStageSessionsDeleted', (e) => {
                this.handleRemoveSession(e.session);
            });
    }

    /**
     * @method handleSessionUpdatedBroadcast
     * @param {object} session
     */
    handleSessionUpdatedBroadcast = (session) => {
        if (this.checkSession(session)) {
            this.handleAddSession(session);
        } else {
            this.handleRemoveSession(session);
        }
    }

    /**
     * @method checkSession
     * @param {object} session
     * @return boolean
     */
    checkSession = (session) => {
        // Check session groups.
        if (session.group_ids) {
            let user_group_ids = User.data.groups.map((group) => group.id);

            let overlap = session.group_ids.filter(value => user_group_ids.includes(value));

            if (!overlap || overlap.length === 0) {
                return false;
            }
        }

        // Check language.
        // TODO To match SessionFilter.php->myLanguage().

        // Check remote-control.
        if (this.remote_control && !session.remote_control) {
            return false;
        }

        return true;
    }

    /**
     * @method handleAddSession
     * @param {object} session
     */
    handleAddSession = (session) => {
        const { sessions } = this.state;

        if (!sessions || sessions.map(s => s.id).indexOf(session.id) === -1) {
            this.fetchSessions(false);
        } else {
            this.setState({
                sessions: sessions.map(s => {
                    if (s.id === session.id) {
                        return session;
                    }

                    return s;
                }),
            });
        }
    }

    /**
     * @method handleRemoveSession
     * @param {object} session
     */
    handleRemoveSession = (session) => {
        const { sessions } = this.state;

        if (sessions) {
            this.setState({
                sessions: sessions.filter(s => s.id !== session.id)
            });
        }
    }

    /**
     * @method updateSessions
     */
    updateSessions = () => {
        let currentSession = null;

        if (this.state.sessions) {
            currentSession = this.state.sessions.find(session => {
                return resourceDateIsBeforeNow(session.starts_at) && (session.ends_at === null || resourceDateIsAfterNow(session.ends_at))
            });
        }

        if (
            currentSession
        ) {
            const state = this.state;
            let updated = false;

            if ((currentSession.id !== this.state.currentSession?.id || currentSession.updated_at?.iso_string !== this.state.currentSession.updated_at?.iso_string)) {
                state.currentSession = currentSession;
                updated = true;
            }

            let currentPoll = null;

            // Current Poll
            if (currentSession.polls.length > 0) {
                // Display the last poll available
                let polls = currentSession.polls.filter(poll =>
                    resourceDateIsBeforeNow(poll.display_from) && (poll.display_until === null || resourceDateIsAfterNow(poll.display_until))
                );

                currentPoll = polls[polls.length - 1];
            }

            if (!isEqual(currentPoll, state.currentPoll)) {
                state.currentPoll = currentPoll;

                updated = true;
            }

            if (updated) {
                this.setState(state);
            }
        } else if (!currentSession && this.state.currentSession) {
            this.setState({
                currentSession: null,
                currentPoll: null,
            });
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return null;
    }
}
